module.exports = __webpack_public_path__ + "media/assets/images/smart_working/1-aws-9d7c8fc0953fe5994eb696fb1b0c5c2f.png";